import { Box, Group, Stack, Text } from '@ekhodealer/ekho-common/rev';

import { MessageTimestamp } from './MessageTimestamp';

export interface SystemMessageProps {
	/** System message text content. */
	body: string;
	/** ISO timestamp of when the system message was created. */
	createdAt: string;
	/** Optional CSS class name for the root element. */
	className?: string;
}

export const SystemMessage = ({ body, createdAt }: SystemMessageProps): React.ReactNode => {
	return (
		<Group
			itemsSpacing='8'
			itemsAlignY='center'
			itemsAlignX='center'
			aria-label={`System message: ${body}`}>
			<Stack itemsSpacing='4' itemsAlignY='center' itemsAlignX='center'>
				<MessageTimestamp createdAt={createdAt} align='center' />
				<Box rounding='full' padding={{ x: 12, y: 6 }} background='secondary'>
					<Group itemsSpacing='8' itemsAlignY='center'>
						<Group.Item>
							<Text size='footnote' color='secondary'>
								{body}
							</Text>
						</Group.Item>
					</Group>
				</Box>
			</Stack>
		</Group>
	);
};
